import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useArticles } from "@/hooks/useArticles";
import { adaptArticles } from "@/lib/adapters";

export function BreakingAlert() {
  const { t, locale } = useI18n();
  const { data } = useArticles(0, 20, "PUBLIE");

  const rawArticles = adaptArticles(
    Array.isArray(data) ? data : (data as any)?.content ?? []
  );

  const alert = rawArticles.find((a) => a.type === "alert");
  if (!alert) return null;

  const title = alert.title[locale] ?? alert.title.fr ?? "";

  return (
    <div className="bg-alert text-alert-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-2.5 flex items-center gap-3 text-sm">
        <span className="inline-flex items-center gap-1.5 rounded bg-alert-foreground/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">
          <AlertTriangle className="h-3 w-3" />
          {t("alert.banner")}
        </span>
        {/* ✅ slug réel interpolé */}
        <Link
          to={`/article/${alert.slug}`}
          className="line-clamp-1 hover:underline underline-offset-2"
        >
          {title}
        </Link>
      </div>
    </div>
  );
}